import { AdStatus } from '$store/models';
import { t } from '$translation/helper';

export function adsStatus(status: AdStatus): string {
  if ([AdStatus.none, AdStatus.paused].indexOf(status) > -1) {
    return t('ads_view_status_stopped');
  } else if (status === AdStatus.approved) {
    return t('ads_view_status_approved');
  } else if (status === AdStatus.active) {
    return t('ads_view_status_active');
  } else if (status === AdStatus.inReview) {
    return t('ads_view_status_in_review');
  } else if (status === AdStatus.declined) {
    return t('ads_view_status_in_declined');
  }
  return 'Unknown';
}
